import { useEffect, useState } from "react";
import { arraySearch } from "../../../redux/actions/searchActions";
import { ICorrespondence } from "../../../interfaces/Correspondence";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducers/rootReducer";
import { CommunicationChannels } from "../../../enums/enums";

function useReturned() {
  const dispatch = useDispatch();
  const [correspondenceFilter, setCorrespondenceFilter]: any = useState();

  const { correspondence } = useSelector(
    (state: AppState) => state.correspondence
  );

  const isNotPqrs = (item: ICorrespondence) => {
    const id = item.id.slice(0, 2);

    return item.isGiveBack && id !== CommunicationChannels.WEB_FORM;
  };

  useEffect(() => {
    const data = correspondence.filter((item) => isNotPqrs(item));
    setCorrespondenceFilter(data);
    dispatch(arraySearch(data));
  }, [correspondence, dispatch]);

  return { correspondenceFilter };
}

export default useReturned;
